import { render, staticRenderFns } from "./RKIModule.vue?vue&type=template&id=e71f53a6&"
import script from "./RKIModule.vue?vue&type=script&lang=js&"
export * from "./RKIModule.vue?vue&type=script&lang=js&"
import style0 from "./RKIModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports